



























import { Component, Watch, Vue } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import Mixin from '../mixin';
import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';
import OrgInfo from '../class/OrgInfo';

@Component({})
export default class Home extends Mixin {
  @Mutation private signIn!: (user: any) => void;
  @Mutation private setCognito!: (user: any) => void;
  @Mutation private showOrg!: (id: string) => void;
  @Mutation private setOrganization!: (org: OrgInfo) => void;
  @State private cognito!: any;
  @State private user!: any;
  @State private organization!: OrgInfo[];
  private name: string = '';
  private pass: string = '';

  private mounted() {
    (this.$el.querySelector('#user') as HTMLInputElement).focus();
  }


  private async login() {
    const button = this.$el.querySelector('#login')! as HTMLInputElement;
    button.disabled = true;
    try {
      if (this.name.length < 1) {
        this.msg('ユーザー名を入力してください');
        (this.$el.querySelector('#user')! as HTMLInputElement).focus();
        return;
      }
      if (this.pass.length < 1) {
        this.msg('パスワードを入力してください');
        (this.$el.querySelector('#pass')! as HTMLInputElement).focus();
        return;
      }
      const user = await Auth.signIn(this.name, this.pass);
      this.setCognito(user);
      if (user.challengeName) {
        this.$router.push('/password');
        return;
      }
      const userInfo = await API.post('api', '/user', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
      });
      this.signIn(userInfo);
      this.msg('ログインしました');
      await this.setOrganization(await API.post('api', '/organization', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
      }));
      if (this.organization.length > 1) {
        this.$router.push('/organization');
      } else {
        this.showOrg(this.user.OrganizationID);
        this.$router.push('/group');
      }
    } catch (ex) {
      this.msg(ex);
    } finally {
      button.disabled = false;
    }
  }

  @Watch('$store.state.user', { immediate: true })
  private async go(val: any) {
    await this.setOrganization(await API.post('api', '/organization', {
      headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
    }));
    if (this.organization.length > 1) {
      this.$router.push('/organization');
    } else {
      this.showOrg(this.user.OrganizationID);
      this.$router.push('/group');
    }
  }

}
